import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { SubscriptionPlanDetailsAPI } from '../api/subscriptionplandetails/subscriptionplanapi';
import { SubscriptionPlanDetailsRequest } from '../api/subscriptionplandetails/subscriptionplandetailsrequest';
import { SubscriptionPlanDetailsResponse } from '../api/subscriptionplandetails/subscriptionplandetailsresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { SubscriptionPlanDetailsAPIProcessorImpl } from '../processor/subscriptionplandetailsapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class SubscriptionPlanDetailsProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(SubscriptionPlanDetailsProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getSubscriptionPlanDetails():APIProcessor<SubscriptionPlanDetailsRequest, SubscriptionPlanDetailsResponse>
    {
        this.logger.log("getSubscriptionPlanDetails() invoked");
        return new SubscriptionPlanDetailsAPIProcessorImpl(this.getContext(), new SubscriptionPlanDetailsAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/subscriptionprocessorfactory.tsx